export const environment = {
  production: true,
  baseUrl: 'https://api-manantial.addcketstudio.com/api/'
};
